export const beforeFormTranslations = {
  en: {
    platformLabel: "Revimo Platform",
    welcomeTitle: "Welcome to your recovery space",
    welcomeDescription:
      "This is the Revimo platform, a place where doing physiotherapy becomes easy and manageable.",
    requiredLabel: "To start",
    intakeTitle: "Shaping our journey from the start",
    intakeDescription:
      "This is an early access version of Revimo. We are actively testing and improving the platform, and your feedback helps us shape the final product. Some features may be incomplete or may change over time — thank you for being part of the journey. See contact options at revimo.eu/en/contact.",
    physioTitle: "Do you have your personal physiotherapist?",
    physioDescription:
      "To use Revimo fully, you need to have a personal physiotherapist who uses Revimo for Physios. You can then connect to a personalized plan created just for you and start doing physiotherapy right away. To connect, enter the custom plan code below in the input field.",
    prePlanTitle: "Complete the pre-plan intake",
    prePlanButton: "Pre-plan intake",
    customPlanTitle: "Enter custom plan code:",
    customPlanPlaceholder: "AB-123-456-789",
  },
  sl: {
    platformLabel: "Platforma Revimo",
    welcomeTitle: "Dobrodošli v vašem prostoru za okrevanje",
    welcomeDescription:
      "To je platforma Revimo, prostor, kjer fizioterapija postane enostavna in obvladljiva.",
    requiredLabel: "Za začetek",
    intakeTitle: "Oblikovanje naše poti od samega začetka",
    intakeDescription:
      "To je zgodnja različica platforme Revimo. Platformo aktivno testiramo in izboljšujemo, vaše povratne informacije pa nam pomagajo oblikovati končni izdelek. Nekatere funkcije so lahko nepopolne ali pa se lahko sčasoma spremenijo — hvala za strpnost, ter da ste del te poti. Naš kontakt najdete na revimo.eu/en/contact, veselimo se vašega mnenja.",
    physioTitle: "Ali imate svojega osebnega fizioterapevta?",
    physioDescription:
      "Za polno uporabo platforme Revimo potrebujete osebnega fizioterapevta, ki uporablja Revimo za fizioterapevte. Nato se lahko povežete s prilagojenim programom, ustvarjenim posebej za vas, in takoj začnete s fizioterapijo. Da se uspešno povežete s programom prosimo, da v spodnje vnosno polje vnesete kodo programa, ki vam jo je dodelil fizioterapevt.",
    prePlanTitle: "Izpolnite uvodni vprašalnik pred načrtom",
    prePlanButton: "Uvodni vprašalnik",
    customPlanTitle: "Vnesite kodo prilagojenega načrta:",
    customPlanPlaceholder: "AB-123-456-789",
  },
} as const;

export type BeforeFormLang = keyof typeof beforeFormTranslations;
